export const OBSERVATION_FILE_MAX_BYTES = 10 * 1024 * 1024;

export const OBSERVATION_FILE_ACCEPT = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png']
};

const ALLOWED_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png'];
const ALLOWED_MIME_TYPES = Object.keys(OBSERVATION_FILE_ACCEPT);

export const validateObservationFile = (file) => {
  if (!file) {
    return 'Seleccioná un archivo.';
  }

  const fileName = (file.name || '').toLowerCase();
  const fileType = (file.type || '').toLowerCase();
  const hasAllowedExtension = ALLOWED_EXTENSIONS.some((extension) => fileName.endsWith(extension));
  const hasAllowedMimeType = fileType ? ALLOWED_MIME_TYPES.includes(fileType) : false;

  if (!hasAllowedMimeType && !hasAllowedExtension) {
    return 'Solo se permiten archivos PDF, JPG, JPEG y PNG.';
  }

  if (file.size > OBSERVATION_FILE_MAX_BYTES) {
    return 'El archivo no puede superar los 10 MB.';
  }

  return '';
};

export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB'];
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / (1024 ** index);

  return `${Math.round(value * 100) / 100} ${units[index]}`;
};

export const observationFileAcceptString = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';
